module.exports = __webpack_public_path__ + "img/icon-wallet.ff8366ab.svg";